import React from "react";

export const LazyCasePageChart = React.lazy(() =>
    import(/* webpackChunkName: "CasePageChart" */ "./CasePageChart").then(
        x => ({ default: x.CasePageChart })
    )
);
